"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = void 0;
var ModelSchema_1 = require("../ModelSchema");
Object.defineProperty(exports, "configure", { enumerable: true, get: function () { return ModelSchema_1.configure; } });
